module.exports = __webpack_public_path__ + "static/screen2-4aade4aa0286cb36ddbf9d26ae74a28f.png";